export default __webpack_public_path__ + "c728b726fce48c07ce1952321fdb9382.png";